import React from "react";
import PropTypes from "prop-types";

import SubmissionsHeaderButtons from "./SubmissionsHeaderButtons";
import LinkToApprovedPhotos from "./LinkToApprovedPhotos";

import { SubmissionsHeadingContainer } from "./styles";

const SubmissionsHeader = ({ username }) => {
    return (
        <SubmissionsHeadingContainer>
            <SubmissionsHeaderButtons username={username} />
            <LinkToApprovedPhotos username={username} />
        </SubmissionsHeadingContainer>
    );
};

SubmissionsHeader.propTypes = {
    username: PropTypes.string.isRequired
};

export default SubmissionsHeader;
